const getRoot = state => state.profile
export const getJobTitle = state => getRoot(state).jobTitle
export const getCompanyName = state => getRoot(state).companyName

export const getCompanyUrl = state => getRoot(state).companyUrl
export const getHandle = state => getRoot(state).handle
export const getGlobalHandle = state => getRoot(state).globalHandle
export const getUniqueHandle = state => getRoot(state).uniqueHandle
export const getCoverPhotoUrl = state => getRoot(state).coverPhotoUrl



// WEBPACK FOOTER //
// ./src/modules/profile/selectors.js